import { Field, useField } from 'formik';
import { Switch } from 'formik-material-ui';
import React from 'react';

const SwitchField = (props) => {
  const { name, label, saveMethod } = props;
  const [field, meta, helpers] = useField(name);

  const onSave = () => {
    saveMethod();
  };

  // Need to remove saveMethod from props
  return (
    <div className="SwitchField form-group">
      {label && <span className="label">{label}</span>}
      <div>
        <Field
          type="checkbox"
          name={name}
          component={Switch}
          onClick={onSave}
          checked={field.value}
          {...field}
          {...props}
        />
      </div>
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
};

export default SwitchField;
